<template>
  <div style="display: flex; flex-direction: column; width: 100%;">
    <el-form
        ref="form"
        :model="innerForm"
        label-width="200px"
        style="flex: 1; margin-left: 140px;">
      <el-form-item
          label="纸张类型"
          prop="pageType"
          :rules="[{ required: true, message: '请选择纸张类型', trigger: ['blur', 'change'] }]">
        <gj-select
            v-model="innerForm.pageType"
            :clearable="false"
            :loading="paperLabelOptionLoading"
            :options="paperLabelOption"
            width="200px"
        ></gj-select>
      </el-form-item>
      <el-form-item
          label="打印数量"
          prop="printQuantity"
          :rules="[
            { required: true, message: '请输入打印数量', trigger: ['blur', 'change'] },
            $gjReRule(RE.pt, '请输入正整数')
          ]">
        <gj-input
            v-model="innerForm.printQuantity"
            width="88px"
        ></gj-input>
        <gj-button
            type="text"
            :disabled="!(innerForm.printQuantity > 0)"
            style="margin-left: 8px"
            @click="printShipmentBoxMark">
          点击打印
          <i v-if="printLoading" class="el-icon-loading" style="line-height: unset;"></i>
        </gj-button>
      </el-form-item>
      <img src="./box_mark.png" class="box-mark--img"/>
    </el-form>
    <el-row
        type="flex"
        align="middle"
        justify="center"
        style="margin-top: 10px;">
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          @click="previousStep"
      >上一步</gj-button>
      <gj-button
          type="primary"
          :loading="loading"
          @click="markFbaShipment"
      >标记出运</gj-button>
    </el-row>
  </div>
</template>

<script>
  import {formMixin, formRuleMixin, formValidatorMixin, stepsMixin} from "../../../../../../../minxins";
  import {getShipmentPageTypes, markFbaShipment, printShipmentBoxMark} from "../../../../../../../api/logistics";

  export default {
    name: "app-step-4",
    mixins: [formMixin, formValidatorMixin, formRuleMixin, stepsMixin],
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        innerForm: {
          pageType: null,
          printQuantity: null
        },
        loading: false,
        paperLabelOption: [],
        paperLabelOptionLoading: false,
        printLoading: false
      }
    },
    created() {
      this.paperLabelOptionLoading = true;
      getShipmentPageTypes()
        .then((data) => {
           this.paperLabelOption = data;
           this.innerForm.pageType = data[0].id;
        })
        .complete(() => this.paperLabelOptionLoading = false)
    },
    methods: {
      markFbaShipment() {
        markFbaShipment(this.id)
          .then(() => {
            this.$gjMessage.success('标记出运成功');
            this.cancel();
          });
      },
      printShipmentBoxMark() {
        if (this.$gjFormValidate()) {
          this.printLoading = true;
          printShipmentBoxMark([{
            id: this.id,
            pageType: this.innerForm.pageType,
            printQuantity: this.innerForm.printQuantity
          }])
            .then((urls) => {
              (urls || []).forEach(url => {
                window.open(url);
              });
            })
            .complete(() => this.printLoading = false);
        }
      }
    }
  }
</script>

<style scoped>
  .box-mark--img {
    width: 500px;
    margin-top: 50px;
  }
</style>
